<template>
  <div class="online-users-card">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center" style="gap:8px;">
        <span class="live-dot"></span>
        <h6 class="mb-0 section-title">Online Users ({{ users.length }})</h6>
      </div>
      <small class="text-secondary">Active in the last 5 minutes</small>
    </div>

    <div v-if="users.length === 0" class="text-center text-secondary py-4">
      <small>No one is online right now.</small>
    </div>

    <div v-else class="table-responsive">
      <table class="table online-users-table mb-0">
        <thead>
          <tr>
            <th>User</th>
            <th>Company</th>
            <th>Role</th>
            <th>Branches</th>
            <th>Last active</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in sortedUsers"
            :key="user.id"
            @click="$emit('select', user)"
            class="user-row"
          >
            <td>
              <div class="d-flex align-items-center" style="gap:10px;">
                <div
                  class="rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold flex-shrink-0"
                  :style="{ background: avatarColor(user.full_name || user.name), width:'32px', height:'32px', fontSize:'.7rem' }"
                >
                  {{ initials(user.full_name || user.name) }}
                </div>
                <div class="min-width-0">
                  <div class="font-weight-bold text-dark text-truncate" style="font-size:.85rem;">{{ user.full_name || user.name }}</div>
                  <small class="text-secondary text-truncate d-block">{{ user.email }}</small>
                </div>
              </div>
            </td>
            <td class="text-dark">{{ user.company ? user.company.name : '—' }}</td>
            <td>
              <span v-if="user.role" class="pill">{{ user.role }}</span>
              <span v-else class="text-secondary">—</span>
            </td>
            <td class="text-dark">{{ user.branch_count || 0 }}</td>
            <td class="text-secondary">{{ relativeTime(user.last_online) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminOnlineUsersTable',
  props: {
    users: { type: Array, default: () => [] },
  },
  computed: {
    sortedUsers() {
      return [...this.users].sort((a, b) => new Date(b.last_online || 0) - new Date(a.last_online || 0));
    },
  },
  methods: {
    initials(name) {
      if (!name) return '?';
      const p = name.trim().split(' ');
      return p.length > 1 ? (p[0][0] + p[1][0]).toUpperCase() : p[0][0].toUpperCase();
    },
    avatarColor(name) {
      const palette = ['#0f172a', '#1e293b', '#334155', '#475569', '#1d4ed8', '#334155'];
      if (!name) return palette[0];
      let h = 0;
      for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
      return palette[Math.abs(h) % palette.length];
    },
    relativeTime(date) {
      if (!date) return '—';
      return moment(date).fromNow();
    },
  },
};
</script>

<style scoped>
.online-users-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 20px;
}
.section-title {
  font-weight: 600;
  color: #0f172a;
}
.live-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0f172a;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: .35; }
  100% { opacity: 1; }
}
.online-users-table thead th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: #94a3b8;
  border-top: none;
  border-bottom: 1px solid #f1f5f9;
  padding: 8px 12px;
  white-space: nowrap;
}
.online-users-table td {
  padding: 10px 12px;
  vertical-align: middle;
  border-top: 1px solid #f8fafc;
  font-size: .85rem;
}
.user-row {
  cursor: pointer;
}
.user-row:hover {
  background: #f8fafc;
}
.pill {
  display: inline-block;
  background: #f1f5f9;
  color: #0f172a;
  font-size: .72rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
}
.min-width-0 {
  min-width: 0;
}
</style>
